import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../../Components/Layout/Footer';
import Header from '../../Components/Layout/Header';
import Navbar from '../../Components/Layout/Navbar';
import CookieConsent, { Cookies } from "react-cookie-consent";

const { $ } = window;
$(document).click(e => {
  const $target = $(e.target);
  let selectors = ["#drop-down"];
  if ($target.closest('#toggleDropDown').length != 0) {
    selectors = selectors.filter(item => item != '#drop-down');
  }

  selectors.push(".mdropdown");
  if ($target.closest('.btn-mdropdown').length != 0) {
    selectors = selectors.filter(item => item != '.mdropdown');
    selectors.push(`.mdropdown[mbutton!="${e.target.id}"]`);
  }

  selectors.push(".mmenu");
  if ($target.closest('.menu-button').length != 0) {
    selectors = selectors.filter(item => item != '.mmenu');
    selectors.push(`.mmenu[mbutton!="${e.target.id}"]`);
  }

  selectors.forEach(item => {
    $(item).animate({
      height: 0,
      opacity: 0,
    }, 250);
  })

});

const LayoutPage = () => {
  return (
    <div className='wrapper'>
      <Navbar />
      <Header />
      <div className="" id="main-content">
        <Outlet />
      </div>
      <Footer />
<CookieConsent
  location="bottom"
  buttonText="I Understand"
  cookieName="designCookies"
  style={{ background: "#2B373B",  }}
  buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
  expires={150}
>
  This website uses cookies to enhance the user experience.{" "}
</CookieConsent>
    </div>
  )
}

export default LayoutPage;
